/** Always keep Western digits (0-9), even when Arabic language is selected. */

const ARABIC_INDIC = "٠١٢٣٤٥٦٧٨٩";
const EXTENDED_ARABIC_INDIC = "۰۱۲۳۴۵۶۷۸۹";

export function toWesternDigits(value: string | number | null | undefined): string {
  if (value == null) return "";
  return String(value).replace(/[٠-٩۰-۹]/g, (digit) => {
    const arabic = ARABIC_INDIC.indexOf(digit);
    if (arabic >= 0) return String(arabic);
    const extended = EXTENDED_ARABIC_INDIC.indexOf(digit);
    return extended >= 0 ? String(extended) : digit;
  });
}

/** Locale tag that keeps Latin numbering for Arabic UI. */
export function displayLocale(isArabic: boolean): string {
  return isArabic ? "ar-EG-u-nu-latn" : "en-US";
}

export function formatLocaleNumber(
  value: number,
  isArabic: boolean,
  options?: Intl.NumberFormatOptions
): string {
  return toWesternDigits(value.toLocaleString(displayLocale(isArabic), options));
}

export function formatLocaleDateTime(
  value: string | Date | null | undefined,
  isArabic: boolean,
  options?: Intl.DateTimeFormatOptions
): string {
  if (!value) return "—";
  const date = value instanceof Date ? value : new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(date.getTime())) return toWesternDigits(String(value));
  return toWesternDigits(date.toLocaleString(displayLocale(isArabic), options));
}

export function formatLocaleDate(
  value: string | Date | null | undefined,
  isArabic: boolean,
  options?: Intl.DateTimeFormatOptions
): string {
  if (!value) return "—";
  const date = value instanceof Date ? value : new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(date.getTime())) return toWesternDigits(String(value));
  return toWesternDigits(date.toLocaleDateString(displayLocale(isArabic), options));
}
